import { JSX, useEffect } from "react";

import { StandardComponents, useLanguage } from "@4pace-cpq/core";
import Box from "@mui/material/Box";
import { useParams } from "@tanstack/react-router";

import { language } from "@/Router";

export function CartIdRouteComponentWrapper(): JSX.Element {
  const { quoteId } = useParams({
    strict: false,
  });

  const { setLanguageById, languages } = useLanguage();

  const languageId = languages.find(
    (lang) => lang.languageCode === language,
  )?.id;

  useEffect(() => {
    if (!quoteId) {
      return;
    }

    if (languageId) {
      setLanguageById(languageId);
    }
  }, [quoteId, setLanguageById, languageId]);

  return (
    <Box sx={{ minHeight: "1100px" }}>
      <StandardComponents.CartIdRouteComponent />
    </Box>
  );
}
